import React from 'react';
import $ from 'jquery'
import { Captcha, Email, CountrySelection, Name, CreateAccountPre} from 'guest-payment';
import CardNumber from 'react-card-number';
import CardSecurityCode from 'react-card-security-code';
import Expiry from 'react-expiry-date';
import AddressEntryField from 'react-address-entry-field';
import PhoneNumber from 'react-phone-number';
import AddressCheckbox from './addressCheckbox'

import AppActions from '../actions/AppActions'
import AppStore from '../stores/AppStore';

import { addShake, parseErrorResponse, parseValErrResp, getErrFields } from '../utility/helper'
import '../utility/csrf'
import CancelAndReturn from '../common/cancelAndReturn'
import LinnerDiv from '../common/lineDiv'

import * as FPT from '../utility/fpt'
import constants from '../constants'
import TemplateData, { localsMessages, guestLocalsMessages } from '../utility/getTemplateData'

import SignUpPanel from '../common/signUpPanel'
import bootstrap from '../../../node_modules/frontend-framework-paypal/dist/twbs/js/modal.js'

const errorMessages = localsMessages('errors/service')
const initialData = JSON.parse(document.getElementById('initialData').innerHTML || {})
const phoneNumberPatternDesc = initialData.phoneNumberPatternDesc || {}
const maxLength = phoneNumberPatternDesc.NATIONAL && phoneNumberPatternDesc.NATIONAL.maxLength || 10
const senderDetails = initialData.senderDetails || {}
const pre_address = senderDetails.address || {}

const defaultCardSpec = constants.DEFAULT_CARD_SPEC

export default React.createClass({

	contextTypes: {
		router: React.PropTypes.object.isRequired
	},

	propTypes: {
		password: React.PropTypes.string
	},

	getInitialState() {

		AppActions.changeCountry({ country: initialData.selectedCountry });

		return {
			isRequired: true,
			postcodeHasError: false,
			refreshingCaptcha: false,
			passwordFieldsOpen: false,
			legalCheckbox: false,
			guestAllowed: TemplateData.guestAllowed,
			memberMandatory: TemplateData.memberMandatory || false,
			charityCountry: TemplateData.charityCountry,
			validPassword: null,
			showPasswordValidationErrors: false,

			supportedCountries: initialData.supportedCountries,
			countriesAllowed: initialData.countriesAllowed,
			phoneNumberCountryCode: initialData.phoneNumberCountryCode,
			country: /*pre_address.iso_country ||*/  initialData.selectedCountry,
			cardSpecs: initialData.cardSpecs,
			initialData: initialData,

			cardSpec: defaultCardSpec,
			maxPhonelength: parseInt(maxLength) + 1, // react-phone-number is appending 0 to all number
			consentShareAddress: false,
			donateNow: '',
			agreeAndDonate: '',
			displayCaptcha: false,
			errorMessages: errorMessages,
			captchaObject: {},
			showServiceErrors: false,
			errorMesages: [],

			isRequired: true,
			errMessageCreditCard: '',
			errMessageExpiry: '',
			errMessageCSC: '',
			errMessageEmail: '',
			errMessagePhoneNumber: '',
			legalCheckboxErrorMsg: '',

			// Auto fill form
			firstname: senderDetails.first_name || '',
			lastname: senderDetails.last_name || '',
			newAddress: {
				line1: pre_address.address1 || '',
				line2: pre_address.address2 || '',
				city: pre_address.city || '',
				state: pre_address.state || '',
				postcode: pre_address.zip || '',
				country: pre_address.iso_country || ''
			},
			phone: senderDetails.phone && senderDetails.phone.phone_number || '',
			email: senderDetails.sender_email || ''
		};
	},

	componentDidMount() {

		$('[type=password]').focus(() => {
			this.setState({
				legalCheckboxErrorMsg: ''
			});
		})
	},

	/*
	* Handle country change
	* Gets new props for new country
	* If country not allowed for guest, it will be redirect to legacy
	*/
	handleCountryChange(country) {

		let { charityCountry } = this.state;

		AppActions.changeCountry({ country: country });

		this.setState({ country: country });

		FPT.trackLinkClickWithData('changeCountry', { country: country });

		if (charityCountry !== country) {

			$('.spinneroverlay').show();
			$.get('/donate/sessionlogout').always(() => {
				window.location.href = TemplateData.guestRedirectUrl + '?cmd=_donations&token=' + TemplateData.token;
			});
		}

		// Keep this - this will be required for crossborder
		// let pathname = window.location.pathname
		// let token = TemplateData.token
		// let signup = TemplateData.signUp
		// let url = `/donate/guest/griffin/${country}?token=${token}&state=${pathname}&signup=${signup}`
		// window.location.href = url
	},

	handleScrollToError() {
		let errorEl = $('.vx_has-error-with-message:visible')
		setTimeout(function(){
			$('html, body').animate({
				scrollTop: errorEl.offset().top
			}, 1000);
		}, 10)
		return
	},


	handleCreditCardBlur (cardnumber) {

		let errMessageCreditCard = ''
		let ccNumberMax = this.state.cardSpec && this.state.cardSpec.fields && this.state.cardSpec.fields.ccNumber && this.state.cardSpec.fields.ccNumber.maxlength

		if (!cardnumber) {
			errMessageCreditCard = errorMessages.REQUIRED_CARD_NUMBER
		} else if (cardnumber && ccNumberMax && (cardnumber.length < (ccNumberMax - 6))) {
			errMessageCreditCard = errorMessages.INVALID_CARD_NUMBER
		}

		this.setState({
			errMessageCreditCard: errMessageCreditCard
		});
	},

	handleChangeCardNumber(cardnumber, cardSpec) {

		this.setState({
			cardnumber: cardnumber,
			cardSpec: cardSpec,
			cardtype: cardSpec.type
		});
	},

	handleCardNumberError(key) {
		this.setState({
			errMessageCreditCard: errorMessages[key]
		});
		this.handleScrollToError()
	},

	handleExpiryBlur (expiration) {

		let errMessageExpiry = ''
		let expYear = expiration.split('/')[1];
		let expYearLen = expYear && expYear.length;

		if (!expiration) {
			errMessageExpiry = errorMessages.REQUIRED_EXPIRY
		} else if (!expYearLen || expYearLen === 1 || expYearLen === 3) {
			errMessageExpiry = errorMessages.INVALID_EXPIRY
		}

		this.setState({
			errMessageExpiry: errMessageExpiry
		});
	},

	handleChangeDate(expiration) {
		this.setState({
			expiration: expiration
		});
	},

	handleExpirationError(key) {
		this.setState({
			errMessageExpiry: errorMessages[key]
		});
		this.handleScrollToError()
	},

	handleChangeSecurityCode(csc) {
		this.setState({
			csc: csc
		});
	},

	handleCSCBlur (csc) {

		let errMessageCSC = ''
		let cscLen = csc && csc.length;
		let cscMax = this.state.cardSpec && this.state.cardSpec.fields && this.state.cardSpec.fields.csc && this.state.cardSpec.fields.csc.maxlength
		let cscMin = this.state.cardSpec && this.state.cardSpec.fields && this.state.cardSpec.fields.csc && this.state.cardSpec.fields.csc.minlength || cscMax

		if (!csc) {
			errMessageCSC = errorMessages.REQUIRED_SECURITY_CODE
		} else if (!(cscLen >= cscMin && cscLen <= cscMax)) {
			errMessageCSC = errorMessages.INVALID_SECURITY_CODE
		}

		this.setState({
			errMessageCSC: errMessageCSC
		});
	},

	handleSecurityCodeError(key) {
		this.setState({
			errMessageCSC: errorMessages[key]
		});
		this.handleScrollToError()
	},

	handleBlurFirstName(name) {
		let firstNameErrorMessage = ''
		if (!name || name === '') {
			firstNameErrorMessage = errorMessages.REQUIRED_FIRST_NAME
		}
		this.setState({
			firstNameErrorMessage: firstNameErrorMessage
		});
	},

	handleFirstNameError(key) {
		this.setState({
			firstNameErrorMessage: errorMessages[key]
		});
		this.handleScrollToError()
	},

	handleChangeFirstName(name) {
		this.setState({
			firstname: name
		});
	},

	handleBlurLastName(name) {
		let lastNameErrorMessage = ''
		if (!name || name === '') {
			lastNameErrorMessage = errorMessages.REQUIRED_LAST_NAME
		}
		this.setState({
			lastNameErrorMessage: lastNameErrorMessage
		});
	},

	handleLastNameError(key) {
		this.setState({
			lastNameErrorMessage: errorMessages[key]
		});
		this.handleScrollToError()
	},

	handleChangeLastName(name) {
		this.setState({
			lastname: name
		});
	},

	handleNameBlur (name) {
		console.log('Name :: ', name);
	},

	handleChangeBillingField(field, value) {

		let newAddress = {
			...this.state.newAddress,
			[field]: value
		}
		this.setState({
			newAddress: newAddress,
			showAddressErrors: false
		});
	},

	handleChangeEmail(email) {
		this.setState({
			email: email
		});
	},

	handleEmailBlur (email) {
		let errMessageEmail = ''
		let emailRex = constants.EMAIL_REX;
		let cusEmail = TemplateData.donationEmail;
		if (emailRex.test(email)) {
			if (cusEmail === email) {
				errMessageEmail = errorMessages.CANNOT_PAY_SELF;
			}
		} else if (email === '') {
			errMessageEmail = errorMessages.MISSING_EMAIL_ID;
		} else {
			errMessageEmail = errorMessages.INVALID_EMAIL_ID;
		}

		this.setState({
			errMessageEmail: errMessageEmail
		});
	},

	handleExistEmailError(key) {
		this.setState({
			errMessageEmail: errorMessages[key]
		});
		this.handleScrollToError()
	},

	handleChangePhone(phone) {
		this.setState({
			phone: phone
		});
	},

	handlePhoneBlur (phone) {
		if (!phone) {
			this.setState({
				errMessagePhoneNumber: errorMessages.REQUIRED_PHONE_NUMBER
			})
		}
	},

	handlePhoneError(key) {
		this.setState({
			errMessagePhoneNumber: errorMessages[key]
		});
		this.handleScrollToError()
	},

	handlePostcodeHasError(postcode) {
		this.setState({
			postcode: postcode
		});
	},

	handleCreateAccountCheckbox(checked) {
		let chkBxStatus = checked ? 'checked' : 'unchecked'
		FPT.trackLinkClickWithData('createAccount', { checkbox: chkBxStatus })
		this.setState({
			passwordFieldsOpen: checked
		});
	},

	// When the account creation form has all the valid input then save it.
	handleCreateAccountAddInfo(state) {
		this.setState(state);
	},

	// Handle reset of all saved fields from account creation form.
	handleCreateAccountResetInfo() {
		this.setState({
			dateOfBirth: null,
			nationality: null,
			occupation: null,
			password: null,
			legalValid: false,
			consentCommunication: false
		});
	},

	handleShareAddress(isChecked) {
		this.setState({consentShareAddress: isChecked});
	},

	handleAddressErrors() {
		this.setState({
			showAddressErrors: true,
			addressErrorMessage: errorMessages.INVALID_BILLING_ADDRESS_CITY_STATE_ZIP
		});
		this.handleScrollToError()
	},

	handleFocus(key) {
		 var ele = {}
		ele[key] = ''
		this.setState(ele)
	},

	handleAddressDefaultValue (item) {
		let keyName = item && item.$
		switch (keyName) {
			case 'line1':
				return pre_address['address1'] || ''
				break;
			case 'line2':
				return pre_address['address2'] || ''
				break;
			case 'city':
				return pre_address['city'] || ''
				break;
			case 'state':
				return pre_address['state'] || ''
				break;
			case 'postcode':
				return pre_address['zip'] || ''
				break;
			default:
				return ''
		}
	},

	setFieldErrors(response) {

		let errorFileds = getErrFields(response);
		let messages = [];
		let showServiceErrors = false;

		for (let i in errorFileds) {
			let key = errorFileds[i].type;

			switch (key) {
				case 'INVALID_CARD_NUMBER':
					this.handleCardNumberError('INVALID_CARD_NUMBER')
					break;
				case 'REQUIRED_CARD_NUMBER':
					this.handleCardNumberError('REQUIRED_CARD_NUMBER')
					break;

				case 'INVALID_SECURITY_CODE':
					this.handleSecurityCodeError('INVALID_SECURITY_CODE')
					break;
				case 'REQUIRED_SECURITY_CODE':
					this.handleSecurityCodeError('REQUIRED_SECURITY_CODE')
					break;

				case 'INVALID_EXPIRY':
					this.handleExpirationError('INVALID_EXPIRY')
					break;
				case 'REQUIRED_EXPIRY':
					this.handleExpirationError('REQUIRED_EXPIRY')
					break;

				case 'REQUIRED_FIRST_NAME':
					this.handleFirstNameError('REQUIRED_FIRST_NAME')
					break;
				case 'INVALID_FIRST_NAME':
					this.handleFirstNameError('INVALID_FIRST_NAME')
					break;

				case 'REQUIRED_LAST_NAME':
					this.handleLastNameError('REQUIRED_LAST_NAME')
					break;
				case 'INVALID_LAST_NAME':
					this.handleLastNameError('INVALID_LAST_NAME')
					break;

				case 'INVALID_BILLING_ADDRESS_CITY_STATE_ZIP':
					this.handleAddressErrors()
					break;

				case 'INVALID_PHONE_NUMBER':
					this.handlePhoneError('INVALID_PHONE_NUMBER')
					break;
				case 'REQUIRED_PHONE_NUMBER':
					this.handlePhoneError('REQUIRED_PHONE_NUMBER')
					break;

				case 'ACCOUNT_ALREADY_EXISTS':
					this.handleExistEmailError('ACCOUNT_ALREADY_EXISTS')
					break;
				case 'MISSING_EMAIL_ID':
					this.handleExistEmailError('MISSING_EMAIL_ID')
					break;
				default:
					// console.warn('Need to Implement for :: ', key);
					showServiceErrors = true;
					let message = errorMessages[key] || errorMessages.VALIDATION_ERROR ;
					if (message) {
						messages.push({
							key: i,
							value: message
						})
					}
			}
		}
		// Updating store with any error messages from server.
		AppActions.updateServerErrors({ serverErrors: messages });
	},

	handleSubmitAnswer (event) {},

	handleRefreshCaptcha(event) {

		// $('.spinneroverlay').show();
		this.setState({
			displayCaptcha: false,
			refreshingCaptcha: true
		});

		$.post('/donate/generatecaptcha').then((result) => {

			// console.log('Result :: ', result);
			if (result && result.data && result.data.captcha) {
				this.setState({
					displayCaptcha: true,
					refreshingCaptcha: false,
					captchaObject: result.data.captcha
				});
				window.setTimeout(() => $('.spinneroverlay').hide(), 500);
			} else {
				$('.spinneroverlay').hide();
			}

		}, () => $('.spinneroverlay').hide())
	},

	handleCreateGuest(event) {

		event.preventDefault();

		if ((this.state.passwordFieldsOpen || TemplateData.memberMandatory) && !this.props.password) {
			this.setState({
				showPasswordValidationErrors: true,
				createaccount: true
			});

			if (!this.state.password) {
				return
			}
		}

		let cusEmail = TemplateData.donationEmail;
		if (cusEmail === this.state.email) {
			this.setState({
				errMessageEmail: errorMessages.CANNOT_PAY_SELF
			});
		}

		if (!AppStore.getDonationAmount() || parseFloat(AppStore.getDonationAmount()) < 0.01) {
			addShake()
			$('html, body').animate({
				scrollTop: $('.money_input').offset().top
			}, 1000);
			return; // block the createGuest action
		}
		if ($('.vx_has-error-with-message').is(':visible')) {
			console.warn('Fix your errors first.');
			this.handleScrollToError();
			return
		} else {
			this.setGuestPaymentData()
		}
	},

	/*
	* setting up guest payment data before executing guest payment.
	*/
	setGuestPaymentData() {

		let myData = AppStore.getAllData() || {}

		let billingAddress = {
			streetaddress1: this.state.newAddress.line1,
			city: this.state.newAddress.city,
			zipcode: this.state.newAddress.postcode,
			country: myData.country
		}
		if (this.state.newAddress && this.state.newAddress.line2) {
			billingAddress.streetaddress2 = this.state.newAddress.line2
		}
		if (this.state.newAddress && this.state.newAddress.state) {
			billingAddress.state = this.state.newAddress.state
		}

		myData.firstname = this.state.firstname
		myData.lastname = this.state.lastname
		myData.phonenumber = this.state.phone
		myData.email = this.state.email

		myData.cardnumber = this.state.cardnumber
		myData.cardtype = this.state.cardtype
		myData.csc = this.state.csc
		myData.expiration = this.state.expiration
		myData.phoneCountryCode = this.state.phoneNumberCountryCode

		myData.consentShareAddress = this.state.consentShareAddress
		myData.billingAddress = billingAddress;

		myData.createaccount = (TemplateData.memberMandatory) ? TemplateData.memberMandatory : this.state.passwordFieldsOpen;
		if (this.state.passwordFieldsOpen || TemplateData.memberMandatory) {
			myData.password = this.state.password || '';
			myData.occupation = this.state.occupation || '';
			myData.nationality = this.state.nationality || '';
			myData.marketingOptin = this.state.consentCommunication || false;
		}

		if (this.state.dateOfBirth && this.state.dateOfBirthPattern) {
			let dobDate = this.state.dateOfBirth.split('/');
			let patterns = this.state.dateOfBirthPattern.split('/');
			myData.dateOfBirth = {
				year: dobDate[patterns.indexOf('YYYY')],
				month: dobDate[patterns.indexOf('MM')],
				day: dobDate[patterns.indexOf('DD')]
			};
		}

		if ($('[name=captchaImage]').is(':visible')) {
			myData.captchaAnswer = $('[name=captchaImage]').val()
		}

		this.setState({
			showAddressErrors: false
		});

		// Updating app store with message = [], as attempt to clean all server errors.
		AppActions.updateServerErrors({ serverErrors: [] });
		AppActions.updateEmail({email: this.state.email});
		AppActions.updateBillingAddress({billingAddress: billingAddress});

		this.handleRequiredValues(myData);
	},


	/*
	* Handling required form fields before executing guest payment
	*/
	handleRequiredValues (params){

		let isValid = true
		let errMessageCreditCard, errMessageExpiry, errMessageCSC, errMessagePhoneNumber, errMessageEmail, firstNameErrorMessage, lastNameErrorMessage
		let keysToValidate = Object.keys(params)

		keysToValidate.forEach((key) => {
			let value = params[key]
			switch (key) {
				case 'cardnumber':
					if (!value) {
						isValid = false
						errMessageCreditCard = errorMessages.REQUIRED_CARD_NUMBER
					}
					break;
				case 'expiration':
					if (!value) {
						isValid = false
						errMessageExpiry = errorMessages.REQUIRED_EXPIRY
					}
					break;
				case 'csc':
					if (!value) {
						isValid = false
						errMessageCSC = errorMessages.REQUIRED_SECURITY_CODE
					}
					break;
				case 'firstname':
					if (!value) {
						isValid = false
						firstNameErrorMessage = errorMessages.REQUIRED_FIRST_NAME
					}
					break;
				case 'lastname':
					if (!value) {
						isValid = false
						lastNameErrorMessage = errorMessages.REQUIRED_LAST_NAME
					}
					break;
				case 'phonenumber':
					if (!value) {
						isValid = false
						errMessagePhoneNumber = errorMessages.REQUIRED_PHONE_NUMBER
					}
					break;
				case 'email':
					if (!value) {
						isValid = false
						errMessageEmail = errorMessages.MISSING_EMAIL_ID
					}
					break;
				default:
					// console.warn('Need error implementation for %s', key)
					break;
			}
		});

		if (isValid) {
			this.submitGuestPayment(params)
		} else {
			this.setState({
				errMessageCreditCard: errMessageCreditCard,
				errMessageExpiry: errMessageExpiry,
				errMessageCSC: errMessageCSC,
				errMessagePhoneNumber: errMessagePhoneNumber,
				errMessageEmail: errMessageEmail,
				firstNameErrorMessage: firstNameErrorMessage,
				lastNameErrorMessage: lastNameErrorMessage
			})
			setTimeout(() => {
				this.handleScrollToError();
			}, 100)
		}
	},


	/*
	* Executing guest payment
	*/
	submitGuestPayment(params) {

		$('.spinneroverlay').show()

		if (this.state.consentShareAddress) {
			FPT.trackLinkClickWithData('consentShareAddress', { consentShareAddress: 'true' })
		}
		FPT.trackLinkClick('donate');

		$.post('/donate/guest', params, (result) => {

			// console.log('Result :: ', result);
			if (result.status === 'redirect') {

				window.location.href = result.url;

			} else if (result.code === 'captcha') {

				this.setState({
					displayCaptcha: true,
					captchaObject: result.captcha
				});

			} else if (result.code === 'CROSS_BORDER' && result.fundingOpts) {

				let fundingOpts = result.fundingOpts[0]
				// Updating store with funding options
				AppActions.updateFundingOptions({ fundingOptions: fundingOpts })

				// Redirect to crossborder handler page.
				this.context.router.push('/donate/guest/crossborder');

			} else if (result.data && result.data.confirmationData) {

				let confirmationData = result.data.confirmationData || {}

				this.handlePaymentSuccess(confirmationData)

			} else if (result.data && result.data.error) {

				let messages = parseErrorResponse(result.data.error, errorMessages)

				// Updating store with any error messages from server.
				AppActions.updateServerErrors({ serverErrors: messages })

			} else if (result.code === 'VALIDATION_ERROR') {

				this.setFieldErrors(result)

			} else if (result.message === 'CC_LINKED_TO_FULL_ACCOUNT') {

				let messages = parseValErrResp(result, errorMessages, 'CC_LINKED_TO_FULL_ACCOUNT')

				// Updating store with any error messages from server.
				AppActions.updateServerErrors({ serverErrors: messages })

			} else if (result.message === 'ISSUER_DECLINE_ERROR') {

				let messages = parseValErrResp(result, errorMessages, 'ISSUER_DECLINE_ERROR')

				// Updating store with any error messages from server.
				AppActions.updateServerErrors({ serverErrors: messages })

			} else if (result.message === 'RISK_DISALLOWED') {

				let messages = parseValErrResp(result, errorMessages, 'RISK_DISALLOWED')

				// Updating store with any error messages from server.
				AppActions.updateServerErrors({ serverErrors: messages })
			} else {
				window.location.href = '/donate/error/payment';
			}
		}).fail(() => {
			// Handle any wierd errors from service
			 window.location.href = '/donate/error/payment';

		}).always(() => {

			$('.spinneroverlay').hide();
			// Checking if captcha exists, simply refreshing after every form submission.
			if (this.state.displayCaptcha) {
				this.handleRefreshCaptcha()
			}
		})
	},

	handlePaymentSuccess(response) {

		AppActions.updateConfirmation({ confirmation: response });

		if (response.guestSignUp && response.experiment && response.experiment.treatment_name === 'US_cause_guest_donation_flow_treatment') {

			FPT.trackPageWithData('main:donate:wps:guest:upgrade', 'main:donate:wps:guest:upgrade:web::', { xe: response.experiment.experiment_id, xt: response.experiment.treatment_id })
			$('#guestCreateAccountdialog').modal('show')

		} else	if (response.guestSignUp && response.experiment && response.experiment.treatment_name === 'US_cause_guest_donation_flow_control') {

			FPT.addPxpTags({ xe: response.experiment.experiment_id, xt: response.experiment.treatment_id })
			return this.handleConfirmation(response)

		} else {
			return this.handleConfirmation(response)
		}
	},

	/*
	* Handling guest payment confirmation page after payment is done
	* case 1 : success payment
	* case 2 : pending payment
	*/
	handleConfirmation(response) {

		if (response.isOfacPending) {
			this.context.router.push('/donate/guest/pending')
		} else {
			this.context.router.push('/donate/guest/confirmation')
		}
	},

	render() {
		const allGuestMessages = guestLocalsMessages()
		const { guestLabels, guestCaptcha: guestCaptchaLabels, guestHelp: guestHelpLabels } = allGuestMessages
		const donateNowLabel = (this.state.passwordFieldsOpen) ? guestLabels.agreeanddonate : guestLabels.donatenow


		let { initialData: { examplePhoneNumber, addressEntryFormat = {}, supportedCountries = [] } } = this.state

		let fields = addressEntryFormat.layout.filter(field => field._ !== undefined);
		let labels = addressEntryFormat.strings;

		let recieveMailLabel = guestLabels.recieveMail
		let recieveMailToolTip = guestLabels.recieveMailToolTip
		let orgName =  TemplateData.donationName;

		recieveMailLabel = recieveMailLabel.replace('{orgName}', orgName);
		recieveMailToolTip = recieveMailToolTip.replace('{orgName}', orgName);
		recieveMailToolTip = recieveMailToolTip.replace('{orgName}', orgName);

		return (<div className="donate_guest_form_wrapper">
					<SignUpPanel {...allGuestMessages.createAccountPost} email={this.state.email}/>
					<div className="row">
						<div className="col-xs-12 col-sm-12 col-md-12 text-center">
							<CountrySelection
								supportedCountries={this.state.supportedCountries}
								defaultValue={this.state.country}
								changeCountry={this.handleCountryChange}/>
						</div>
					</div>
				<div className="row">
					<div className="col-xs-12 col-sm-12 col-md-12 text-center creditcard_number">
						<CardNumber
							showIsRequiredError={this.state.isRequired}
							handleFocus={() => this.handleFocus('errMessageCreditCard')}
							handleBlur={this.handleCreditCardBlur}
							errorMessage={this.state.errMessageCreditCard}
							cardSpecs={this.state.initialData.cardSpecs}
							label={guestLabels.cardnumber}
							handleChangeCardNumber={this.handleChangeCardNumber}/>
					</div>
					<div className="col-xs-6 col-sm-6 col-md-6 text-center expiry_component">
						<label id="guestExpirationLabel"
							style={{ width: '100%', marginTop: 14, textAlign: 'left', fontWeight: 'bold' }} >
								{guestLabels.expiration}
						</label>
						<Expiry
							showIsRequiredError={this.state.isRequired}
							handleFocus={() => this.handleFocus('errMessageExpiry')}
							handleBlur={this.handleExpiryBlur}
							errorMessage={this.state.errMessageExpiry}
							cardSpec={this.state.cardSpec}
							handleChangeDate={this.handleChangeDate}
							helpText={guestHelpLabels.expiration}
							label={guestHelpLabels.expiration} />
					</div>
					<div className="col-xs-6 col-sm-6 col-md-6 text-center csc_component">
						<label id="guestCSCLabel"
							style={{ width: '100%', marginTop: 14, textAlign: 'left', fontWeight: 'bold' }}>
							{guestLabels.csc}
						</label>
						<CardSecurityCode
							showIsRequiredError={this.state.isRequired}
							handleFocus={() => this.handleFocus('errMessageCSC')}
							handleBlur={this.handleCSCBlur}
							errorMessage={this.state.errMessageCSC}
							style={{ marginTop: 0 }}
							handleChangeSecurityCode={this.handleChangeSecurityCode}
							cardSpec={this.state.cardSpec}
							label={guestLabels.cscplaceholder}/>
					</div>
				</div>
				<div className="name_component">
					<Name
						firstNameLabel={guestLabels.firstname}
						lastNameLabel={guestLabels.lastname}
						required={this.state.isRequired}
						firstNameDefaultValue={this.state.firstname}
						firstNameErrorMessage={this.state.firstNameErrorMessage}
						handleChangeFirstName={this.handleChangeFirstName}
						handleBlurFirstName={this.handleBlurFirstName}
						handleFocusFirstName={() => this.handleFocus('firstNameErrorMessage')}
						lastNameDefaultValue={this.state.lastname}
						lastNameErrorMessage={this.state.lastNameErrorMessage}
						handleChangeLastName={this.handleChangeLastName}
						handleBlurLastName={this.handleBlurLastName}
						handleFocusLastName={() => this.handleFocus('errMessageLastName')}/>
				</div>
				{this.state.showAddressErrors ?
					<div className="col-xs-12 col-sm-12 col-md-12 service_error_holder vx_has-error-with-message">
						<p className="text-left">
							<span className="vx_alert-icon icon icon-small icon-critical-small" aria-hidden="true"></span>
							{this.state.addressErrorMessage}
						</p>
					</div> : null}
				<label id="guestBillingLabel"
					style={{ width: '100%', marginTop: 5, textAlign: 'left', fontWeight: 'bold' }} >
					{guestLabels.billing}
				</label>
				<div className="row address_fields"
					style={{ marginTop: -10 }}>
					{fields.map(field =>
						<AddressEntryField
							key={`${field.$}`}
							{...field}
							id={`billing_${field.$}`}
							value={this.handleAddressDefaultValue(field)}
							fieldName={field.$}
							labels={labels}
							country={this.state.country}
							handleChangeField={this.handleChangeBillingField}
							handlePostcodeHasError={this.handlePostcodeHasError}/>)}
				</div>

				{TemplateData.isShipping ? <AddressCheckbox changeAddress={this.handleShareAddress} label={recieveMailLabel} toolTipText={recieveMailToolTip}/> : null}

				<label id="guestContactInfLabel"
								style={{ width: '100%', marginTop: 14, marginBottom: 0, textAlign: 'left', fontWeight: 'bold' }}>
					{guestLabels.contactinfo}
				</label>
				<div style={{ marginTop: 5 }} className="phone_holder">
					<PhoneNumber
						label={guestLabels.phone}
						exampleNumber={examplePhoneNumber}
						handleFocus={() => this.handleFocus('errMessagePhoneNumber')}
						handleBlur={this.handlePhoneBlur}
						errorMessage={this.state.errMessagePhoneNumber}
						country={this.state.country}
						value={this.state.phone}
						maxlength={this.state.maxPhonelength}
						showIsRequiredError={this.state.isRequired}
						changePhone={this.handleChangePhone}/>
				</div>
				<div style={{ marginTop: 10 }} className="email_holder">
					<Email label={guestLabels.email}
						handleFocus={() => this.handleFocus('errMessageEmail')}
						errorMessage={this.state.errMessageEmail}
						handleBlur={this.handleEmailBlur}
						value={this.state.email}
						required={this.state.isRequired}
						changeEmail={this.handleChangeEmail}/>
				</div>
				<div>
					<div className="password_fields" style={{ marginTop: 20, textAlign: 'initial' }}>
						<CreateAccountPre {...allGuestMessages.createAccountPreProps}
							mandatory={this.state.memberMandatory}
							country={this.state.country}
							supportedCountries={this.state.supportedCountries}
							handleCreateAccountCheckbox={this.handleCreateAccountCheckbox}
							handleValidInfo={() => { }}
							resetValidInfo={() => { }}
							handleAllValidInfo={this.handleCreateAccountAddInfo}
							resetAllValidInfo={this.handleCreateAccountResetInfo}
							showValidationErrors={this.state.showPasswordValidationErrors}/>
					</div>
				</div>

			{this.state.refreshingCaptcha ?
				<div className="col-xs-12 col-sm-12 col-md-12 loading_captcha_holder">
					<div className="smalldonatespinner">
						<div className="spinnerholder">
							<div className="spinner"></div>
						</div>
						<div className="loadingcontent">
							<p className="">{guestLabels.refreshingCaptcha}</p>
						</div>
					</div>
				</div> : null}

			{this.state.displayCaptcha ?
				<div className="captcha_holder">
					<Captcha
						captchaObject={this.state.captchaObject}
						refreshContent={guestCaptchaLabels.refresh}
						submitContent={guestCaptchaLabels.verify}
						textInputLabel={guestCaptchaLabels.codelabel}
						toggleAudioContent="ToggleAudioContent"
						submitAnswer={this.handleSubmitAnswer}
						refreshCaptcha={this.handleRefreshCaptcha}/>
				</div> : null}

			<div style={{ maxWidth: 360, margin: '20px auto' }}>
				<button type="button"
					id="guestPaymentBtn"
					className="vx_btn vx_btn-block"
					onClick={this.handleCreateGuest} >
					{donateNowLabel}
				</button>
			</div>
			<CancelAndReturn />
		</div>
		);
	}
});



// WEBPACK FOOTER //
// ./guest/guestForm.js